<template>
    <div class="home-page">
        <div class="home-title-wrapper">
            <div class="home-title-container">
                <h1 v-html="focus.cartouche ? focus.cartouche.titre : ''"></h1>
                <p v-html="focus.cartouche ? focus.cartouche.texte : ''"></p>
            </div>
            <img src="../../assets/images/courtage/Giordano Courtage_Accueil en haut.png"/>
        </div>
        <div class="page-link-wrapper">
            <div class="page-link-container">
                <div class="flex">
                    <div>
                        <h3 v-html="focusAssurance.cartouche ? focusAssurance.cartouche.titre : ''"></h3>
                        <p v-html="focusAssurance.cartouche ? focusAssurance.cartouche.texte : ''"></p>
                        <router-link :to="{ name: 'Assurance' }">
                            <button class="cg-btn cg-btn-primary">Découvrir nos solutions</button>
                        </router-link>
                    </div>
                    <img width="360px" height="auto" src="../../assets/images/courtage/visuel@3x.webp">
                </div>
            </div>
        </div>
        <div class="page-link-wrapper">
            <div class="page-link-container">
                <div class="flex">
                    <img width="360px" src="../../assets/images/courtage/financement_img.png">
                    <div>
                        <h3 v-html="focusFinancement.cartouche ? focusFinancement.cartouche.titre : ''"></h3>
                        <p v-html="focusFinancement.cartouche ? focusFinancement.cartouche.texte : ''"></p>
                        <router-link :to="{ name: 'Financement' }">
                            <button class="cg-btn cg-btn-primary">Découvrir nos solutions</button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="home-form-wrapper">
            <div class="home-form-container">
                <h4 v-html="focusFinancement.formulaire ? focusFinancement.formulaire.titre : ''"></h4>
                <p v-html="focusFinancement.formulaire ? focusFinancement.formulaire.texte : ''"></p>
                <router-link :to="{ name: 'DemandePretForm' }">
                    <button class="cg-btn cg-btn-primary">Quelle est votre situation ?</button>
                </router-link>
            </div>
        </div>
        <site-link siteName="Courtage"></site-link>
    </div>
</template>

<script>
import SiteLink from '../Components/SiteLink.vue'
import { getFocus } from '../../mixins/getFocus'

export default {
    name: 'CourtageHome',
    components: {
        SiteLink
    },
    mixins: [getFocus],
    data() {
        return {
            focus: {},
            focusAssurance: {},
            focusFinancement: {}
        }
    },
    async beforeMount() {
        await this.getFocus('cg', 'Accueil')
        .then(res => {
            this.focus = res
        })
        await this.getFocus('cg', 'Assurances & Prévoyance')
        .then(res => {
            this.focusAssurance = res
        })
        await this.getFocus('cg', 'Financement Immo & Pro')
        .then(res => {
            this.focusFinancement = res
        })
    }
}
</script>